import Auth from "../Auth";
import { adminRecords } from "./adminRecords";
import React, { useEffect, useState } from "react";

const StoryEngineGate = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [emailInput, setEmailInput] = useState("");
  const [message, setMessage] = useState("");
  const [isUngated, setIsUngated] = useState(false);

  useEffect(() => {
    refreshTable();
  }, []);


  const handleEmailChange = (event) => {
    setEmailInput(event.target.value);
  };

  const handleEmailSubmit = (event) => {
    event.preventDefault();

    const emails = emailInput.split("\n").map((email) => email.trim());

    let toggledCount = 0;
    let notFoundCount = 0;
    let noToggleCount = 0;
    const notFoundList = [];
    const noToggleList = [];
    const toggledList = [];

    const updatePromises = emails.map((email) => {
      const subscriptionRef = adminRecords.collection("subscriptions").where("email", "==", email);

      return subscriptionRef
        .get()
        .then(async (querySnapshot) => {
          if (querySnapshot.empty) {
            console.log(`No subscription found for email: ${email}`);
            notFoundCount++;
            notFoundList.push(email);
            return;
          }

          for (const subscriptionDoc of querySnapshot.docs) {
            const subscriptionData = subscriptionDoc.data();
            const featureField = isUngated ? "storyEngineUngated" : "storyEngine";
            const updateData = { ...subscriptionData };
            if (updateData.features && updateData.features[featureField]) {
              noToggleCount++;
              noToggleList.push(email);
              return;
            } else {
              updateData.features = { ...subscriptionData.features, [featureField]: true };
            }

            toggledCount++;
            toggledList.push(email);
            await Auth.fetchWithIdToken(`/api/admin/user/${encodeURIComponent(subscriptionDoc.id)}/gates`, { features: { [featureField]: true } });
          }

          return true;
        })
        .catch((err) => {
          console.error(`Error updating subscription for email: ${email}`, err);
          throw err;
        });
    });

    Promise.all(updatePromises)
      .then(() => {
        console.log("All subscriptions updated successfully");
        setEmailInput("");
        const messageParts = [`Subscriptions updated successfully. Toggled: ${toggledCount}, No Toggle Required: ${noToggleCount}, Not Found: ${notFoundCount}`];
        if (toggledList.length > 0) {
          messageParts.push(` | Gained Access: ${toggledList.join(", ")}`);
        }
        if (noToggleList.length > 0) {
          messageParts.push(` | Already had access: ${noToggleList.join(", ")}`);
        }
        if (notFoundList.length > 0) {
          messageParts.push(` | Not Found: ${notFoundList.join(", ")}`);
        }
        setMessage(messageParts.join("\n"));
        refreshTable();
      })
      .catch((err) => {
        console.error("Error updating subscriptions:", err);
        setMessage(`Error updating subscriptions: ${err.message}`);
      });
  };

  const handleRemoveClick = (id) => {
    Auth.fetchWithIdToken(`/api/admin/user/${encodeURIComponent(id)}/gates`, { features: { storyEngineUngated: false, storyEngine: false } })
      .then(() => {
        console.log("Subscription ${id} updated successfully");
        refreshTable();
      })
      .catch((err) => {
        console.error("Error updating subscription ${id}:", err);
        setMessage("Error updating subscription ${id}:", err.message);
      });
  };

  const refreshTable = () => {
    const subscriptionsRef = adminRecords.collection("subscriptions");
    const storyEngineUngatedRef = subscriptionsRef.where("features.storyEngineUngated", "==", true);
    const storyEngineRef = subscriptionsRef.where("features.storyEngine", "==", true);

    Promise.all([storyEngineUngatedRef.get(), storyEngineRef.get()])
      .then(([ungatedQuerySnapshot, storyEngineQuerySnapshot]) => {
        const combineResults = (querySnapshot) =>
          querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        const ungatedSubs = combineResults(ungatedQuerySnapshot);
        const storyEngineSubs = combineResults(storyEngineQuerySnapshot);

        // Merge results and remove duplicates
        const subscriptions = [
          ...new Map([...ungatedSubs, ...storyEngineSubs].map((item) => [item.id, item])).values(),
        ];

        setSubscriptions(subscriptions);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  };

  const handleCheckboxChange = () => {
    setIsUngated(!isUngated);
  };

  if (loading) {
    return <p>Loading subscriptions...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      <form onSubmit={handleEmailSubmit}>
        <label>
          Paste in emails (one per line):
          <br />
        </label>
        <textarea
          value={emailInput}
          onChange={handleEmailChange}
          style={{ width: "400px", height: "200px" }}
        />
        <br />
        <label>
          <input
            type="checkbox"
            checked={isUngated}
            onChange={handleCheckboxChange}
          />
          Bypass Pro and Max Plan Requirement
        </label>
        <br />
        <button type="submit">Update Subscriptions</button>
      </form>
      <br />
      {message && <p>{message}</p>}
      <br />
      <br />

      <p>Total user with access: {subscriptions.length}</p>

      <table style={{ borderCollapse: "collapse", border: "1px solid #ccc" }}>
        <thead>
          <tr>
            <th style={{ padding: "10px" }}>Subscription ID</th>
            <th style={{ padding: "10px" }}>Email</th>
            <th style={{ padding: "10px" }}>Bypass Plan?</th>
            <th style={{ padding: "10px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map((subscription) => (
            <tr key={subscription.id}>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>{subscription.id}</td>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>{subscription.email}</td>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>{subscription.features.storyEngineUngated ? "true" : "false"}</td>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                <button
                  type="button"
                  onClick={() => handleRemoveClick(subscription.id)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default StoryEngineGate;
